import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, Plus } from "lucide-react";
import api from "@/lib/api";
import LoaderOlimpo from "@/components/LoaderOlimpo";
import useRefetchOnFocus from "@/hooks/useRefetchOnFocus";

export default function Procesos() {
  const nav = useNavigate();
  const [procesos, setProcesos] = useState([]);
  const [cola, setCola] = useState([]);
  const [cargando, setCargando] = useState(true);

  const cargar = async () => {
    const { data } = await api.get("/procesos");
    setProcesos(data.procesos || []);
    setCola(data.cola || []);
    setCargando(false);
  };
  useEffect(() => { cargar(); }, []);
  useRefetchOnFocus(cargar, !cargando);

  const empezar = async (focoId) => {
    const { data } = await api.post("/proceso", { foco_id: focoId });
    nav(`/proceso/${data.proceso.id}`);
  };

  const andando = procesos.filter((p) => p.impl_estado === "andando");
  const empezados = procesos.filter((p) => p.impl_estado !== "andando");

  if (cargando) return <LoaderOlimpo />;

  return (
    <div className="max-w-[900px] mx-auto w-full px-6 md:px-8 py-14">
      <div className="flex items-center justify-between mb-12 gap-4 flex-wrap">
        <h1 className="titulo text-4xl">Mis procesos.</h1>
        <button className="btn-dorado flex items-center gap-2" onClick={() => nav("/diagnostico?agregar=1")} data-testid="agregar-proceso">
          <Plus size={15} /> AGREGAR UN PROCESO
        </button>
      </div>
      <p className="text-gris text-sm -mt-8 mb-12" data-testid="agregar-proceso-nota">¿Se te ocurrió algo nuevo para sumar? Contámelo y lo agrego a tu mapa sin rehacer todo.</p>

      <div className="mb-14">
        <div className="mono-label text-verde mb-5">ANDANDO</div>
        {andando.length === 0 && <p className="text-gris text-sm">Todavía no pusiste ninguno a andar.</p>}
        <div className="space-y-3">
          {andando.map((p, i) => (
            <motion.div key={p.id} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }} className="card-dark p-5 flex flex-wrap gap-4 items-center justify-between" style={{ borderColor: "rgba(111,191,169,0.4)" }} data-testid={`andando-${i}`}>
              <div className="flex items-center gap-3">
                <Check size={18} className="text-verde" />
                <span className="text-crema">{p.nombre}</span>
              </div>
              <div className="flex flex-wrap items-center gap-3">
                <span className="mono-label text-dorado">{p.horas_mes} H/MES</span>
                <button className="btn-dorado min-h-[44px] !px-4" onClick={() => nav(`/implementar/${p.id}`)} data-testid={`abrir-andando-${i}`}>ABRIR PROCESO</button>
                <button className="btn-fantasma min-h-[44px] !px-4" onClick={() => nav(`/proceso/${p.id}`)} data-testid={`editar-andando-${i}`}>EDITAR</button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {empezados.length > 0 && (
        <div className="mb-14">
          <div className="mono-label text-gris mb-5">EMPEZADOS</div>
          <div className="space-y-3">
            {empezados.map((p, i) => (
              <div key={p.id} className="card-dark p-5 flex items-center justify-between" data-testid={`empezado-${i}`}>
                <span className="text-crema">{p.nombre}</span>
                <button className="btn-fantasma !py-2 !px-4" onClick={() => nav(p.estado === "definido" ? `/implementar/${p.id}` : `/proceso/${p.id}`)} data-testid={`seguir-${i}`}>SEGUIR</button>
              </div>
            ))}
          </div>
        </div>
      )}

      <div>
        <div className="mono-label text-gris mb-5">EN LA COLA</div>
        {cola.length === 0 && <p className="text-gris text-sm" data-testid="cola-vacia">La cola está vacía. Cuando se te ocurra algo nuevo, tocá AGREGAR UN PROCESO acá arriba y lo sumo a tu mapa.</p>}
        <div className="space-y-3">
          {cola.map((f, i) => (
            <motion.div key={f.id} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }} className="card-dark p-5 flex items-center justify-between" style={i === 0 ? { borderColor: "rgba(201,168,76,0.4)" } : {}} data-testid={`cola-${i}`}>
              <div>
                {i === 0 && (
                  <div className="mb-1">
                    <div className="mono-label text-dorado">POR ACÁ CONVIENE EMPEZAR</div>
                    <div className="text-gris text-xs mt-1" data-testid="cola-criterio">Ordenado por lo que más rápido podés poner a andar, no solo por horas.</div>
                  </div>
                )}
                <div className="text-crema">{f.titulo}</div>
                <div className="mono-label text-gris mt-1">{f.horas_mes} H/MES · USD {f.plata_anio?.toLocaleString("es-AR")}/AÑO</div>
              </div>
              <button className="btn-dorado !py-2.5 !px-5" onClick={() => empezar(f.id)} data-testid={`empezar-${i}`}>EMPEZAR CON ESTE</button>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
